module.exports = __webpack_public_path__ + "static/media/epic_gem_small.2056dd5b.png";